export const CRM_SIDEBAR_UPDATE = 'CRM_SIDEBAR_UPDATE';